// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AssetCategory,
  AssetPlacement,
} from "./types";


export default __t.row({
  assetId: __t.u64().primaryKey().name("asset_id"),
  scope: __t.string(),
  get category() {
    return AssetCategory;
  },
  name: __t.string(),
  description: __t.string(),
  tags: __t.string(),
  thumbnailUrl: __t.option(__t.string()).name("thumbnail_url"),
  format: __t.option(__t.string()),
  boundsMinX: __t.option(__t.f64()).name("bounds_min_x"),
  boundsMinY: __t.option(__t.f64()).name("bounds_min_y"),
  boundsMinZ: __t.option(__t.f64()).name("bounds_min_z"),
  boundsMaxX: __t.option(__t.f64()).name("bounds_max_x"),
  boundsMaxY: __t.option(__t.f64()).name("bounds_max_y"),
  boundsMaxZ: __t.option(__t.f64()).name("bounds_max_z"),
  get placement() {
    return AssetPlacement;
  },
  isGround: __t.bool().name("is_ground"),
  clipsGround: __t.bool().name("clips_ground"),
});
